"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SearchWithFilter_1 = __importDefault(require("@Components/Search/SearchWithFilter"));
const contexts_1 = require("@App/contexts");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const validate_1 = require("@App/helpers/validate");
const RadioSelectionTab_1 = __importDefault(require("@Components/WorkRegistrationSubs/AddWriter/RadioSelectionTab"));
const SearchResult_1 = __importDefault(require("@Components/WorkRegistrationSubs/SearchResult"));
const writer_form_type_1 = require("@App/enum/writer-form-type");
require("./index.scss");
const format_name_1 = require("@App/helpers/format-name");
const WriterAddForm = ({ setFoundWriterToDraft, onRadioButtonClicked, expanded, expandedChanged, }) => {
    const { workStore, writerSearchStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [searchWasPerformed, setSearchWasPerformed] = (0, react_1.useState)(false);
    const onSubmitSearch = (0, mobx_1.action)((value) => __awaiter(void 0, void 0, void 0, function* () {
        if ((0, validate_1.IPIValidator)(value, true)) {
            writerSearchStore.setWriterSearch({
                ipiNameNumber: value,
            });
        }
        else {
            writerSearchStore.setWriterSearch({
                fullName: value,
            });
        }
        yield writerSearchStore.searchWriters();
        setSearchWasPerformed(true);
    }));
    const onClear = () => {
        writerSearchStore.clearStore();
        setSearchWasPerformed(false);
    };
    const isValidIPI = (ipiNumber) => (ipiNumber ? (0, validate_1.IPIValidator)(ipiNumber, true) : true);
    const writerRoles = (searchResult) => {
        if (searchResult.entity.ipiNumber && isValidIPI(searchResult.entity.ipiNumber)) {
            return [{ name: 'IPI Number', value: searchResult.entity.ipiNumber }];
        }
        return [];
    };
    const itemWasAdded = (ipId) => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        return workDraftFromLocal.writers.findIndex((item) => ipId === item.ipId) !== -1;
    };
    const writersSearchModelHasData = writerSearchStore.writersSearchModel && writerSearchStore.writersSearchModel.count > 0;
    const SearchIsLoadingText = () => react_1.default.createElement("p", null, "Searching, please wait...");
    return (react_1.default.createElement("div", { className: 'writer-add-form' },
        react_1.default.createElement("h2", null, "Add Writer"),
        react_1.default.createElement(RadioSelectionTab_1.default, { id: 'search-for-writer-tab', name: 'Search for a writer', onClick: onRadioButtonClicked, defaultChecked: true, forceChecked: expanded },
            react_1.default.createElement("div", { className: "writer-sub-form-component" },
                react_1.default.createElement(SearchWithFilter_1.default, { mainColor: true, id: 'writer-search', placeholder: "Search writer's name or IPI Number", withFilter: false, buttonClick: (value) => __awaiter(void 0, void 0, void 0, function* () {
                        if (expandedChanged) {
                            expandedChanged(writer_form_type_1.WriterFormType.add);
                        }
                        yield onSubmitSearch(value);
                    }), onClearInput: onClear, searchFieldClicked: onRadioButtonClicked }),
                expanded &&
                    (writerSearchStore.isSearching ? (react_1.default.createElement(SearchIsLoadingText, null)) : (writersSearchModelHasData && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("p", { className: 'suggested-title' }, "Pick from Suggested Writers"),
                        react_1.default.createElement("div", { className: 'suggested' }, writerSearchStore.writersSearchModel.results.map((data) => (react_1.default.createElement(SearchResult_1.default, { key: data.entity.id, title: (0, format_name_1.formatName)(data.entity.firstName, data.entity.lastName), onAddClicked: () => setFoundWriterToDraft(data.entity, true), onItemWasAdded: () => itemWasAdded(data.entity.ipId), roles: writerRoles(data), addButtonText: 'Add writer' })))))))),
                searchWasPerformed && !writersSearchModelHasData && (react_1.default.createElement("div", { className: 'suggested-title' }, "Not found"))),
            searchWasPerformed && expanded && (react_1.default.createElement("div", { className: 'suggested-title' }, "Can't find what you're looking for?")))));
};
exports.default = (0, mobx_react_1.observer)(WriterAddForm);
